import { secondaryColors, neutralColors } from '../tokens/color';

export const enecoTextLinkColors = {
  // High emphasis variant
  textLinkHighEmphasisDefaultTextColor: secondaryColors.accentGreen700,
  textLinkHighEmphasisHoverTextColor: secondaryColors.accentGreen800,
  textLinkHighEmphasisFocusTextColor: secondaryColors.accentGreen800,
  textLinkHighEmphasisDefaultUnderlineColor: secondaryColors.accentGreen300,
  textLinkHighEmphasisHoverUnderlineColor: secondaryColors.accentGreen800,
  textLinkHighEmphasisFocusUnderlineColor: neutralColors.neutralBlack,
};
